<script>
import { Overlay } from '../../'
import { standardIndicator } from '../../workspace/standard-indicators.mjs'
export default {
    name: 'ChoppinessIndex', mixins: [Overlay],
    methods: {
        meta_info() { return { author:'TradingCandle',version:'1.0.0',desc:'Logarithmic true-range-to-price-range ratio',
            preset:{ name:'Choppiness Index $length',side:'offchart',settings:{color:'#7e57c2',lineWidth:1.5} } } },
        use_for() { return ['ChoppinessIndex'] },
        calc() { return {
            props:{length:{def:14,text:'Length'},annualization:{def:252,text:'Periods per year'}},
            conf:{renderer:'Spline'},
            update:`const count = Math.max(2, Math.floor(length)) * 2 + 1;
                const values = series => Array.from({length: count}, (_,i) => series[i]);
                return (${standardIndicator.toString()})('ChoppinessIndex', values(high), values(low), values(close), [], length, annualization);`
        } },
    },
}
</script>
